// src/components/common/TOTPDisplay.js

import React, { useState, useEffect } from 'react';

export default function TOTPDisplay({ secret }) {
    const [token, setToken] = useState('------');
    const [timeLeft, setTimeLeft] = useState(30);
    const [copySuccess, setCopySuccess] = useState('');

    useEffect(() => {
        if (!secret || typeof window.OTPAuth === 'undefined') {
            return;
        }

        let totp;
        try {
            let cleanSecret = secret.trim();
            
            // Tenta extrair secret de URLs otpauth:// se o usuário colou o link inteiro
            if (cleanSecret.includes('otpauth://')) {
                try {
                    const url = new URL(cleanSecret);
                    const secretParam = url.searchParams.get('secret');
                    if (secretParam) cleanSecret = secretParam;
                } catch (e) {}
            }

            // Remove espaços e caracteres inválidos (Base32 permite apenas A-Z e 2-7)
            cleanSecret = cleanSecret.toUpperCase().replace(/[^A-Z2-7]/g, '');

            if (!cleanSecret) {
                setToken('Chave Vazia');
                return;
            }

            totp = new window.OTPAuth.TOTP({
                issuer: "Arcus",
                label: "Intranet",
                algorithm: 'SHA1',
                digits: 6,
                period: 30,
                secret: cleanSecret,
            });
        } catch (e) {
            console.error("Erro ao inicializar o TOTP:", e);
            setToken('Chave Inválida');
            return;
        }

        const updateToken = () => {
            try {
                const newToken = totp.generate();
                const remaining = totp.period - (Math.floor(Date.now() / 1000) % totp.period);
                setToken(newToken);
                setTimeLeft(remaining);
            } catch (e) {
                setToken('Chave Inválida');
                clearInterval(intervalId);
            }
        };

        updateToken();
        const intervalId = setInterval(updateToken, 1000);

        return () => clearInterval(intervalId);
    }, [secret]);

    const handleCopy = () => {
        if (token && token !== '------' && token !== 'Chave Inválida') {
            navigator.clipboard.writeText(token.replace(/\s/g, ''));
            setCopySuccess('Copiado!');
            setTimeout(() => setCopySuccess(''), 2000);
        }
    };

    if (!secret) {
        return null;
    }

    const progressPercentage = (timeLeft / 30) * 100;

    return (
        <div className="mt-4 p-3 bg-slate-700/50 rounded-lg">
            <p className="text-sm font-bold text-slate-400 mb-2">Código 2FA (TOTP)</p>
            <div className="flex items-center gap-4">
                <p className="text-3xl font-mono tracking-widest text-cyan-300">
                    {token.slice(0, 3)} {token.slice(3, 6)}
                </p>
                <button onClick={handleCopy} className="text-slate-400 hover:text-white">
                    {copySuccess ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
                    )}
                </button>
            </div>
            <div className="w-full bg-slate-600 rounded-full h-1.5 mt-2">
                <div className="bg-cyan-500 h-1.5 rounded-full transition-all duration-1000 linear" style={{ width: `${progressPercentage}%` }}></div>
            </div>
        </div>
    );
}